import React from 'react';
import { motion } from 'framer-motion';
import { Tag } from './ui/Tag';
import { tomos } from '../data/tomos';
export function TomosSection() {
  return <section id="tomos" className="w-full bg-white py-20 sm:py-28" aria-labelledby="tomos-title" data-id="element-163" data-mp="1kar0e5zcfasv">
      <div className="mx-auto w-full max-w-6xl px-6" data-id="element-164" data-mp="1p5n5a6pohsne">
        <div className="mx-auto max-w-2xl text-center" data-id="element-165" data-mp="1u2wrldhrto70">
          <Tag data-id="element-166" data-mp="1u4hk6xkiyx28">Lo Que Recibís</Tag>
          <h2 id="tomos-title" className="mt-6 font-serif text-3xl font-bold leading-tight text-[#0f172a] sm:text-4xl lg:text-5xl" data-id="element-167" data-mp="xd5x3e9hc117">
            Los 6 Tomos del Sistema
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600" data-id="element-168" data-mp="16dc54kmes8sz">
            Cada tomo es un sistema completo en sí mismo. Juntos forman el manual de
            operaciones de tu alimentación atlética.
          </p>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-169" data-mp="2hrfxxnh9fqwg">
          {tomos.map((tomo, index) => <motion.li key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.45,
          delay: index % 3 * 0.08
        }} className="flex flex-col overflow-hidden rounded border border-slate-200 bg-white transition-shadow duration-200 hover:shadow-[0_18px_40px_-24px_rgba(15,23,42,0.45)]" data-id="element-170" data-mp="2mq0zbq890gmh" data-mpi={index}>
              <div className={`${tomo.accent} px-6 py-5`} data-id="element-171" data-mp="27pmlydoh8hiy">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/75" data-id="element-172" data-mp="27r7b1ns0v89f">
                  {tomo.id}
                </p>
                <h3 className="mt-1 font-serif text-xl font-bold leading-snug text-white" data-id="element-173" data-mp="1yy431v05bnm6">
                  {tomo.title}
                </h3>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-174" data-mp="1oylm7nfj8hyc">
                <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400" data-id="element-175" data-mp="1oyd51jcdmqhc">
                  {tomo.category}
                </p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600" data-id="element-176" data-mp="1abmvxvsevtl7">
                  {tomo.description}
                </p>
                <p className={`mt-6 border-t border-slate-100 pt-4 text-sm font-bold ${tomo.accentText}`} data-id="element-177" data-mp="1fcu4hx2dowsx">
                  {tomo.saving}
                </p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}